import { Fragment } from "react";

const WORDS = ["Canlı TV", "Film", "Dizi", "Spor", "Belgesel", "Çocuk", "Müzik", "500.000+ İçerik"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <section className="relative border-y border-white/10 bg-[#08072a] py-2 overflow-hidden" data-testid="marquee">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center">
            {row.map((w, i) => (
              <Fragment key={`${k}-${i}`}>
                <span className={`font-display uppercase text-xs md:text-sm font-normal tracking-[0.2em] px-4 ${i % 2 ? "text-[#a4a6ff]" : "text-white/90"}`}>{w}</span>
                <span className="h-1 w-1 md:h-1.5 md:w-1.5 rounded-full moon shrink-0" />
              </Fragment>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
